// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  hasSubmitSucceeded,
  isPristine,
} from 'redux-form'

// Since the submit handler can be called before the form component itself can rerender
// the formProps that are available in the submit handler can actually contain cached values
// so instead of trusting that, ask redux directly for these values when determining
// if to trigger auto-submit in CDM and to properly
// handle various work flows in the DB search forms.

const submittedFormIsPristine = formName => (dispatch, getState) => (
  isPristine(formName)(getState()) && hasSubmitSucceeded(formName)(getState())
)

export default submittedFormIsPristine
